import React from 'react';
import Code from '../components/Code.jsx';
import { WxLink } from '@watkinslabs/watkinsx-components';

const SHOWCASE = 'https://eizo.watkinsx.com/watch/station/p882c974006d1ffa?track=zSTrz_IU2ZeqTXRts7dDlw';

const DOCS = [
  ['README', 'quick start, core concepts, the player, the Builder and audio'],
  ['docs/platform.md', 'the map of the parts and how they fit'],
  ['docs/api.md', 'every function: loading, Player, performance, publishing, Builder'],
  ['docs/format.md', 'the scene document format'],
  ['docs/pulsescript.md', 'PulseScript: display list, events, drawing, sandbox'],
  ['docs/binary.md', 'the .pulse binary format and measured sizes'],
  ['bench/README.md', 'the renderer benchmark and its results'],
];

export default function StartSection() {
  return (
    <section className="sec sec-last" id="start" aria-labelledby="start-h">
      <div className="wrap">
        <header className="sec-head">
          <p className="kicker">Get started</p>
          <h2 id="start-h">One script tag, or one import.</h2>
          <p className="sec-lead">
            The runtime has no dependencies and needs WebGL2 (Chrome and Edge 56+, Firefox 51+, Safari 15+) and Web
            Audio. The pure parts, validation, the Builder, lyrics, easing, paths, particles and expressions, also run
            in Node 18+. The npm package is not on the public registry yet; in a checkout of the repository,
            run <code>npm install &amp;&amp; npm run build</code> to get <code>dist/</code>.
          </p>
        </header>
        <div className="start-grid">
          <div>
            <h3 className="mini-h">Drop in a player</h3>
            <Code label="The pulse-player element">{`<script src="pulse.umd.min.js"></script>
<pulse-player src="scene.json" controls autoplay loop></pulse-player>`}</Code>
            <h3 className="mini-h">Or load from code</h3>
            <Code label="Loading from code">{`import Pulse from '@watkinslabs/pulse';

const player = await Pulse.load('scene.pulse', {
  container: document.querySelector('#stage'),
  autoplay: true, loop: true,
});
player.on('quality', e => console.log(e.level, e.reason));`}</Code>
          </div>
          <div>
            <h3 className="mini-h">Author a scene with the Builder</h3>
            <Code label="The Builder">{`const d = Pulse.doc({ width: 1280, height: 720, duration: 8 }).beats(120);

d.text('Hello, Pulse', { size: 96, weight: 800 })
  .reveal('char', { stagger: .05, ease: 'out_back' })
  .onBeat(0.05);
d.circle(0, 0, 40, { fill: '#22e8ff' })
  .throw({ x: 200, y: 600 }, { x: 420, y: -900 });          // a parabola
d.widget('radial_spectrum', { bins: 96 }, { size: { w: 400, h: 400 } });
d.post('bloom', { intensity: Pulse.bind('bass', { value: .6, gain: 1 }) });

const player = await d.play({ container, autoplay: true });`}</Code>
          </div>
        </div>
        <div className="docs-row">
          {DOCS.map(([name, text]) => (
            <div className="doc-link" key={name}>
              <b>{name}</b><span>{text}</span>
            </div>
          ))}
        </div>
        <p className="license">
          Pulse is MIT licensed; source on GitFoundry (private for now). The documentation above ships in the
          repository. See it at length in <WxLink href={SHOWCASE}>Kernel Space</WxLink>,
          the all-vector Pulse showcase on EIZO&rsquo;s station.
        </p>
      </div>
    </section>
  );
}
